export { containsEmoji } from './contains-emoji';
export { isPasswordValid, passwordRules, validatePasswordConditionSeparatly } from './is-password-valid';

export const isDexcomEnabled = () => import.meta.env.VITE_APP_IS_DEXCOM_ENABLED === 'true';
export const isGivingEnabled = () => import.meta.env.VITE_APP_IS_GIVING_ENABLED === 'true';
export const isSignUpOrganizationEnabled = () => import.meta.env.VITE_APP_SIGN_UP_ORGANIZATION === 'true';
export const areTomorrowTodosEnabled = () => import.meta.env.VITE_APP_TOMORROW_TODOS_ENABLED === 'true';
